export const mutations = {

    authStoreAccessToken(state, data) {
        state.accessToken = data
    },

    authSwitchImpersonateToken(state, data) {
        state.impersonateToken = state.accessToken;
        state.accessToken = data
    },

    authLeaveImpersonate(state) {
        state.accessToken = state.impersonateToken;
        state.impersonateToken = null;
    },

    authStoreRefreshToken(state, data) {
        state.refreshToken = data
    },

    authStoreCurrentUser(state, data) {
        state.currentUser = data
    },

    resetState(state) {
        state.accessToken = null;
        state.refreshToken = null;
        state.impersonateToken = null;
        state.currentUser = {};
        state.enableRefresh = true;
    }

};
